import React from "react";

import { useTranslation } from "../../../core/translation.core";
import FindCustomerIcon from "../../../icons/posicons/findCustomer.icon";
import PlusIcon from "../../../icons/posicons/plus.icon";
import ScanMemberIcon from "../../../icons/posicons/scanMember.icon";

const btnStyle =
  "bg-her-blue hover:bg-opacity-80 text-white p-3 lg:p-5 w-full rounded-md text-base lg:text-xl font-medium flex-center gap-3";

interface IProps {
  setShowScanMember: any;
  setShowFindCustomer: any;
  setAddShowCustomer: any;
  setChooseOption: any;
}

export default function ChooseOption({ setAddShowCustomer, setShowFindCustomer, setShowScanMember, setChooseOption }: IProps) {
  const { t, msg } = useTranslation();

  const handleShowScanMember = () => {
    setShowScanMember(true);
    setAddShowCustomer(false);
    setShowFindCustomer(false);
    setChooseOption(false);
  };

  const handleShowFindCustomer = () => {
    setShowFindCustomer(true);
    setAddShowCustomer(false);
    setShowScanMember(false);
    setChooseOption(false);
  };

  const handleShowAddCustomer = () => {
    setAddShowCustomer(true);
    setShowScanMember(false);
    setShowFindCustomer(false);
    setChooseOption(false);
  };

  return (
    <div id="customer-source-selector" className="space-y-12 lg:space-y-16 flex flex-col justify-center p-2 lg:p-6 ">
      <h1 className="text-2xl lg:text-4xl">{t(msg.customer.findCustomer)}</h1>

      <button onClick={handleShowScanMember} className={btnStyle}>
        <ScanMemberIcon />
        <span>{t(msg.pos.scanMemberCode)}</span>
      </button>

      <button id="customer-source-find" onClick={handleShowFindCustomer} className={btnStyle}>
        <FindCustomerIcon />
        <span>{t(msg.pos.findCustomer)}</span>
      </button>

      <button
        onClick={handleShowAddCustomer}
        className="bg-white text-her-blue border-her-blue hover:bg-opacity-90 border-4 p-3 lg:p-5 w-full rounded-md text-base lg:text-xl font-medium flex-center gap-3"
      >
        <PlusIcon />
        <span>{t(msg.pos.addNewCustomer)}</span>
      </button>
    </div>
  );
}
